"use client";

import React, { useRef } from "react";
import styles from "./Confirm.module.css";
import {
	AlertDialogActions,
	AlertDialogContent,
	AlertDialogRoot,
	AlertDialogTitle,
	AlertDialogViewport,
} from "../AlertDialog";
import { Button } from "../Button";
import { useConfirm } from "./useConfirm";
import { Translate } from "@/components/Translate";

export type ConfirmProps = {};

export const ConfirmRoot = ({}: ConfirmProps) => {
	const { open, state, cancel, confirm, pending } = useConfirm();

	const laggedState = useRef(state);

	if (state !== undefined) {
		laggedState.current = state;
	}

	return (
		<AlertDialogRoot
			open={open}
			onOpenChange={(open) => {
				if (!open) {
					cancel();
				}
			}}
		>
			<AlertDialogViewport backdropBlur>
				<AlertDialogContent>
					<AlertDialogTitle>{laggedState.current?.title}</AlertDialogTitle>
					{laggedState.current?.description && <p>{laggedState.current.description}</p>}
					<AlertDialogActions justify="start">
						<Button
							loading={pending}
							onClick={confirm}
							size="full"
							color="black"
							className={styles.btn}
						>
							{laggedState.current?.confirmText || <Translate>Confirm</Translate>}
						</Button>
						<Button onClick={cancel} size="full" color="outlined" className={styles.btn}>
							{laggedState.current?.cancelText || <Translate>Cancel</Translate>}
						</Button>
					</AlertDialogActions>
				</AlertDialogContent>
			</AlertDialogViewport>
		</AlertDialogRoot>
	);
};
